import { CommonModule } from '@angular/common';
import { FormsModule }   from '@angular/forms';
import { NgModule,Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from "@angular/router";
import { AcpsharedService } from '../../../services/acpshared.service';
import { ProjectService } from '../../../services/project.service';
import { AcpService } from '../../../services/acp.service';
@Component({
  selector: 'app-acpnav',
  templateUrl: './acpnav.component.html',
  styleUrls: ['./acpnav.component.css']
})
export class AcpnavComponent implements OnInit {
	
  projectString: string;
  IsACPUserLoggedIn : boolean;
  ACPLoggedUserName : String;
  ACPProjectIdentifier : String;
  ACPprojectName: string;
  ACPLoggedUserType: string;
  projectSetting: any;
  userNumber: any = 1;
  gstNumber:any =1;
  paymentNumber:any =1;
  docNumber: any = 1;
  searchNumber: any = 1;
  reportsNumber: any = 1;
  ubaNumber: any = 1;
  rightsaccessNumber: any = 1;
  emailsettingsNumber: any = 1;
  appsettingsNumber: any = 1;
  reportsettingsNumber: any = 1;
  reconcilationNumber: any = 1;
  declarationSettingNumber: any = 1;
  
  constructor(private router: Router,private route: ActivatedRoute,private acpsharedService: AcpsharedService,private acpService: AcpService,private projectService: ProjectService) {
	 
	this.acpsharedService.ACPLoggedUserType.subscribe( value => {
        this.ACPLoggedUserType = value;
	  });
	  this.acpsharedService.IsACPUserLoggedIn.subscribe( value => {
		this.IsACPUserLoggedIn = value;
		this.getUserAccessNav();
      });
	  this.acpsharedService.ACPProjectIdentifier.subscribe( value => {
        this.projectString = value;
		this.getProjectIdentifier(this.projectString);
	  });
	 
  }
  
  ngOnInit() {
  } 

	 getProjectIdentifier(projId) { 	 
		this.projectService.getProjIdentifier(projId).subscribe( res => {
			this.projectSetting = res['data'];
			let resultData = res['data'];
			
			if(resultData.hasOwnProperty('projectName')){
				this.acpsharedService.ACPprojectName.subscribe( value => {
					this.ACPprojectName = value;
				});
				this.acpsharedService.ACPprojectName.next(this.projectSetting.projectName);
				/*if(typeof this.ACPLoggedUserType !== "undefined" && this.ACPLoggedUserType!="") {	
					this.getUserAccessNav();
				}*/
			}else{
				this.router.navigate(['404']);
			}
		});
	}
	
		 getUserAccessNav() {
			 if(this.ACPLoggedUserType && typeof this.IsACPUserLoggedIn !== "undefined" && this.IsACPUserLoggedIn){
		  		this.acpService.getRolesNewNav(this.projectString,this.projectSetting.projectIdentifier,this.ACPLoggedUserType).then(userRoles => {
					for(let pages of Object.values(userRoles)) {
							if(pages.page == 'user') {	
								var accFunc = pages.functionality;		
								if(accFunc.includes('view') == true || this.ACPLoggedUserType=='1') { 
								this.userNumber = 0; 
								} else { this.userNumber = 1;
								}				
							}
							if(pages.page == 'doc') {	
								var accFunc = pages.functionality;		
								if(accFunc.includes('view') == true || this.ACPLoggedUserType=='1') { 
								this.docNumber = 0; 
								} else { this.docNumber = 1;
								}				
							}
							if(pages.page == 'searchsection') {	
									var accFunc = pages.functionality;		
									if(accFunc.includes('view') == true || this.ACPLoggedUserType=='1') { 
									this.searchNumber = 0; 
									} else { this.searchNumber = 1;
									}									
							}		 
							if(pages.page == 'reports') {	
									var accFunc = pages.functionality;		
									if(accFunc.includes('view') == true || this.ACPLoggedUserType=='1') { 
									this.reportsNumber = 0; 
									} else { this.reportsNumber = 1;
									}								
							}
							if(pages.page == 'uba') {	
									var accFunc = pages.functionality;		
									if(accFunc.includes('view') == true || this.ACPLoggedUserType=='1') { 
									this.ubaNumber = 0; 
									} else { this.ubaNumber = 1;
									}									
							}
							if(pages.page == 'rightsaccess') {	
									var accFunc = pages.functionality;		
									if(accFunc.includes('view') == true || this.ACPLoggedUserType=='1') { 
									this.rightsaccessNumber = 0; 
									} else { this.rightsaccessNumber = 1;
									}									
							}
							if(pages.page == 'emailsettings') {	
									var accFunc = pages.functionality;		
									if(accFunc.includes('view') == true || this.ACPLoggedUserType=='1') { 
									this.emailsettingsNumber = 0; 
									} else { this.emailsettingsNumber = 1;
									}								
							}
							if(pages.page == 'appsettings') {	
								var accFunc = pages.functionality;		
								if(accFunc.includes('view') == true || this.ACPLoggedUserType=='1') { 
								this.appsettingsNumber = 0; 
								} else { this.appsettingsNumber = 1;
								}				
							}
							if(pages.page == 'reportsettings') {	
								var accFunc = pages.functionality;		
								if(accFunc.includes('view') == true || this.ACPLoggedUserType=='1') { 
								this.reportsettingsNumber = 0; 
								} else { this.reportsettingsNumber = 1;
								}								
						}
							if(pages.page == 'gst') {	
								var accFunc = pages.functionality;		
								if(accFunc.includes('view') == true || this.ACPLoggedUserType=='1') { 
								this.gstNumber = 0; 
								} else { this.gstNumber = 1;
								}				
							}
							if(pages.page == 'paymentsettings') {	
								var accFunc = pages.functionality;		
								if(accFunc.includes('view') == true || this.ACPLoggedUserType=='1') { 
								this.paymentNumber = 0; 
								} else { this.paymentNumber = 1;
								}				
							}

							if(pages.page == 'reconcilation') {	
									var accFunc = pages.functionality;		
									if(accFunc.includes('view') == true || this.ACPLoggedUserType=='1') { 
									this.reconcilationNumber = 0; 
									} else { this.reconcilationNumber = 1;
									}								
							}
							if(pages.page == 'declarationsetting') {	
								var accFunc = pages.functionality;		
								if(accFunc.includes('view') == true || this.ACPLoggedUserType=='1') { 
								this.declarationSettingNumber = 0; 
								} else { this.declarationSettingNumber = 1;
								}								
						}
						
					}
					
				});   
			}
	  }
}